module.exports = __webpack_public_path__ + "img/banner-es.dbd56579.png";